import styled, { keyframes, css } from 'styled-components';
import media from 'styles/media';
import _round from 'lodash/round';
import { PrimaryButton as Button, SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { HelpLabel } from 'styles/elements/label';
import { ColumnDiv } from 'styles/elements/div';
import { Error } from 'styles/blocks/error';
import { ReceivedHTML } from './receivedHTML';
import Text from './text';

/*  Makes tiny styling change so that browser will repaint.
    Needed for Safari as it does not repaint once component is mounted,
    instead incorrectly calculating the absolutely positioned parent height on component enter (DEV-3850)
*/
const repaint = keyframes`
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
`;

// props.containerWidth is the true width of the parent container. It is the width including any scrollbars.
const Question = styled.form`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: ${props => (props.containerWidth ? `${props.containerWidth}px` : '100%')};
  box-sizing: border-box;
  padding: 30px ${props => (props.containerWidth ? (
    `${_round(props.containerWidth * (props.theme.paddingPercentageHorizontalLargeScreen / 100))}px`
  ) : (
    `${props.theme.paddingPercentageHorizontalLargeScreen}%`
  ))};
  background: ${props => props.theme.backgroundColorPrimary};
  ${media.smallAndBelow`
    padding: 10px ${props => (props.containerWidth ? `${_round(props.containerWidth * 0.035)}px` : '3.5%')};
  `}
`;

const InnerContainer = styled(ColumnDiv)`
  ${!document.cookie && media.smallAndBelow`
      padding-bottom: 180px;
  `}
  ${props => (media.safari && props.shouldRepaint ? css`
   animation: ${repaint} 1ms;
  ` : '')};
`;

const ButtonSmall = styled(SecondaryButton)`
  border: none;
  margin: 0;
  display: flex;
  ${media.smallAndBelow`
    padding: 5px 0;
  `}
`;

const AlertLabel = styled(HelpLabel)`
  background: ${props => props.theme.infoAlertColor};
  padding: 0.6em;
  margin-bottom: 20px;
`;

const ETriageHelpLabel = styled(HelpLabel)`
  padding-top: 10px;
`;

Question.Text = Text;
Question.InnerContainer = InnerContainer;
Question.Button = Button;
Question.ButtonSmall = ButtonSmall;
Question.Error = Error;
Question.HelpLabel = HelpLabel;
Question.ETriageHelpLabel = ETriageHelpLabel;
Question.ReceivedHTML = ReceivedHTML;
Question.AlertLabel = AlertLabel;

export default Question;
